import React from 'react'; // useEffect is not needed for this logic
import { useWebSocket } from '../websocket/WebSocketContext';

const AnimatedBackground = () => {

  const { connected } = useWebSocket();

  // FIX: Simply derive the colors based on the 'connected' boolean.
  // No useEffect needed. When 'connected' changes, this component re-renders
  // and selects the correct object automatically.
  const colors = connected ? {
    // "Sweet Green" Theme (Connected)
    wave1: 'rgba(52, 211, 153, 1)',   // Bright Emerald Green
    wave2: 'rgba(16, 185, 129, 1)',   // Medium Green
    wave3: '#064e3b'                  // Deep Forest Green
  } : {
    // Original Theme (Disconnected)
    wave1: 'rgba(46, 164, 223, 1)',   // Original Blue
    wave2: 'black',                   // Original Black
    wave3: '#062632ff'                // Original Dark Blue
  };

  return (
    <>
      <div className='box'>
        <div
          className='wave -one'
          style={{ background: colors.wave1 }}
        ></div>
        <div
          className='wave -two'
          style={{ background: colors.wave2 }}
        ></div>
        <div
          className='wave -three'
          style={{ background: colors.wave3 }}
        ></div>
      </div>

      <style>{`
        /* All original CSS styles for the page */
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

        /* Waves background animation */
        .box {
          position: fixed;
          top: 0;
          transform: rotate(80deg);
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 0;
          pointer-events: none; /* Prevents blocking clicks on content */
        }

        .wave {
          position: absolute;
          opacity: 0.4;
          width: 1500px;
          height: 1300px;
          margin-left: -150px;
          margin-top: -250px;
          transform-origin: 50% 48%;
          border-radius: 43%;
          animation: drift 10000ms infinite linear;
          transition: background 1s ease; /* Smooth transition between colors */
        }

        .wave.-three {
          animation: drift 9500ms infinite linear;
        }

        .wave.-two {
          animation: drift 5000ms infinite linear;
          opacity: 0.1;
        }

        @keyframes drift {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default AnimatedBackground;